__webpack_require__.p = "/dev/843-wc-ajout-du-behavior-b-resize-on-arrow-drag/";